import { configure } from 'mobx'
import { createContext, FC, PropsWithChildren, useContext } from 'react'
import  RootStore  from './root-store'

configure({ enforceActions: 'never' })

const rootStore = RootStore
const StoreContext = createContext<any>(rootStore)

export const StoreProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  return (
    <StoreContext.Provider value={rootStore}>{children}</StoreContext.Provider>
  )
}

export const useRootStore = () => useContext(StoreContext)
